import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CurrentSiteIdStore } from '../current-site-id.store';
import { EntityMutationDomain, EntityMutationEvent } from './entity-mutation.model';

// Root-singleton pub/sub for entity mutations. Hot Subject with no replay on purpose: pages always
// fetch fresh on ngOnInit, so an event fired while no page listened needs no delivery later.
@Injectable({ providedIn: 'root' })
export class EntityMutationBusService {
  private readonly currentSiteIdStore = inject(CurrentSiteIdStore);

  private readonly eventsSubject = new Subject<EntityMutationEvent>();

  readonly events$: Observable<EntityMutationEvent> = this.eventsSubject.asObservable();

  publish(event: EntityMutationEvent): void {
    this.eventsSubject.next(event);
  }

  // Events for one domain that apply to the site the user is currently viewing. Site membership is
  // evaluated per event at delivery time, so a site switch mid-stream never refetches for a site
  // the user has already left.
  eventsFor(domain: EntityMutationDomain): Observable<EntityMutationEvent> {
    return this.events$.pipe(
      filter(
        (event) =>
          event.domain === domain && (event.siteId === undefined || event.siteId === this.currentSiteIdStore.get()),
      ),
    );
  }
}
